import { render } from "./IndexErrorDialog.vue?vue&type=template&id=e40d66f4"
import script from "./IndexErrorDialog.vue?vue&type=script&lang=js"
export * from "./IndexErrorDialog.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IndexErrorDialog.vue"]])

export default __exports__